import * as React from 'react';
import ErrorPage from '../components/error-page';


export default ({pageContext: {availablePrismicBlogs}}) => <ErrorPage availablePrismicBlogs={availablePrismicBlogs} code='500' text='Internal server error. Please try again later.'/>